// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2VE5i","title":"Info_title__3uG5q","selects":"Info_selects__fhOdn","requiredAsterisk":"Info_requiredAsterisk__3ncZc"};